module.exports = __webpack_public_path__ + "static/media/artes_graficas.810b591c.jpg";